import React from 'react';
import { Text, Icon } from '@fluentui/react';
import { Trans } from 'react-i18next';
import { StringConstants } from 'app/utils/constants';
import './CategoryCards.scss';

export interface CategoryCardConfig {
    key: string;
    title: string;
    pageTitle?: string;
    description: string;
    iconName: string;
    requestType: string;
    flowId: number;
    linkId: number;
}

/** The five Request Help entry categories, also reused by Step 4's editable Request Type dropdown. */
export const CATEGORIES: CategoryCardConfig[] = [
    {
        key: 'sales',
        title: 'Sales question',
        description: 'Questions about pricing, or purchasing options.',
        iconName: 'Shop',
        requestType: StringConstants.QUESTION,
        flowId: 2,
        linkId: 1,
    },
    {
        key: 'css',
        title: 'CSS Escalation',
        description: 'Escalate an existing CSS support case.',
        iconName: 'Headset',
        requestType: StringConstants.REVIEW_REQUEST,
        flowId: 7,
        linkId: 2,
    },
    {
        key: 'warranty',
        title: 'Warranty & Services',
        pageTitle: 'Warranty need',
        description: 'Requests related to warranty, repairs and services.',
        iconName: 'Shield',
        requestType: StringConstants.POST_SALES,
        flowId: 13,
        linkId: 3,
    },
    {
        key: 'feature',
        title: 'Feature request',
        description: 'Suggest a new feature or improvement.',
        iconName: 'FavoriteStar',
        requestType: StringConstants.IRT,
        flowId: 9,
        linkId: 4,
    },
    {
        key: 'cpe',
        title: 'CPE Support',
        description: 'Engage with a CPE representative',
        iconName: 'Chat',
        requestType: StringConstants.IRT,
        flowId: 10,
        linkId: 5,
    },
];

interface CategoryCardsProps {
    selectedCategory: string | null;
    onCategorySelect: (key: string, requestType: string, flowId: number, linkId: number, title: string) => void;
}

const CategoryCards: React.FC<CategoryCardsProps> = ({ selectedCategory, onCategorySelect }) => {
    return (
        <div className="category-cards-container">
            {CATEGORIES.map((card) => (
                <button
                    key={card.key}
                    className={`category-card ${selectedCategory === card.key ? 'category-card--selected' : ''}`}
                    onClick={() => onCategorySelect(card.key, card.requestType, card.flowId, card.linkId, card.pageTitle || card.title)}
                    aria-pressed={selectedCategory === card.key}
                    aria-describedby="request-help-title"
                    data-testid={`category-card-${card.key}`}
                >
                    <div className="category-card-body">
                        <div className="category-card-icon-container">
                            <Icon iconName={card.iconName} className="category-card-icon" />
                        </div>
                        <Text className="category-card-title">
                            <Trans>{card.title}</Trans>
                        </Text>
                        <Text className="category-card-desc">
                            <Trans>{card.description}</Trans>
                        </Text>
                    </div>
                </button>
            ))}
        </div>
    );
};

export default CategoryCards;
